import { WithSubpages } from '../../subpages';
import { voiceSubpages } from '../../subpages/dictionary';
import { PAGE_TITLE } from '../../consts';

import { MAIN_PAGE_PATH } from './paths';

const VOICE = () => <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.VOICE} items={voiceSubpages} />;

export default VOICE;
